import { render, staticRenderFns } from "./veSbzcJzwRoomEdit.vue?vue&type=template&id=67dd09b1&scoped=true"
import script from "./veSbzcJzwRoomEdit.vue?vue&type=script&lang=js"
export * from "./veSbzcJzwRoomEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dd09b1",
  null
  
)

export default component.exports